import { render, staticRenderFns } from "./ReceiptRejectDetailQuery.vue?vue&type=template&id=642fde3e"
import script from "./ReceiptRejectDetailQuery.vue?vue&type=script&lang=js"
export * from "./ReceiptRejectDetailQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports